export const wscIntegrationFragment = `
   wscIntegration {
     __typename
     ... on WscContentIntegration {
       wscContentType
       wscLabels
       contentHeight
     }
   }
`
